

    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import { ApiClient } from "@/utilities/ApiClient";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Prop } from "vue-property-decorator";
    import * as toastr from "toastr";
    import { EmployeeVM, IEmployeeVM } from "@/model/Api/VM/EmployeeVM";
    import { Watch } from "vue-property-decorator";
    import { IEmployeeBookingVM } from "@/model/Api/VM/EmployeeBookingVM";
    import { Utils } from "@/utilities/Utils";
    import FoodVoucherModal from "@/views/Modals/FoodVoucherModal.vue";

    @Component({
        components: {
            ApiButton,
            FoodVoucherModal
        }
    })

    export default class EmployeesTab extends Vue {

        /* eslint-disable */

        @Watch("searchText")
        onTextChanged(value: string) {
            if (value === "") {
                this.$emit("loadAvailableEmployees");
            }
            this.bookingAvailableEmployeeSearch();
        }


        //
        // -- properties
        //

        @Prop({}) private booking !: BookingVM;
        @Prop({}) private employees !: Array<IEmployeeBookingVM>;
        @Prop({}) private availableEmployees !: Array<IEmployeeVM>;

        private showEmployees: boolean = true;
        private showAvailableEmployees: boolean = true;
        private searchText: string = "";


        //
        // -- methods
        //

        hasVoucherAmount(voucher: number) {
            if (voucher > 0) return true;
            else return false
        } 

        hasVoucher(voucher: string) {
            return Utils.isEmptyOrWhitespace(voucher)
        } 

        private async bookingAvailableEmployeeSearch() {
            await this.$emit("bookingAvailableEmployeeSearch", this.searchText);
        }

        toggleShowEmployees() {
            if (!this.showEmployees) { return this.showEmployees = true }
            if (this.showEmployees) { return this.showEmployees = false }
        }

        toggleShowAvailableEmployees() {
            if (!this.showAvailableEmployees) { return this.showAvailableEmployees = true }
            if (this.showAvailableEmployees) { return this.showAvailableEmployees = false }
        }

        async loadAll() {
            this.$emit("loadEmployees");
            this.$emit("loadAllocationsDetail");
            this.$emit("loadRoomTotals");
            this.$emit("loadAvailableEmployees");
        }

        private async search() {
            this.availableEmployees = [];
            const response = await ApiClient.get(`/Api/Booking/BookingAvailableEmployeeSearch?contractorID=${this.booking.contractorID}&bookingID=${this.booking.id}&searchText=${this.searchText}`);
            this.availableEmployees.push(...response.map((e: IEmployeeVM) => new EmployeeVM(e)));
        }

        async addEmployee(employee: IEmployeeVM, event: Event) {
            if (this.booking.isDisabled) return;
            const postData = { bookingID: this.booking.id, employeeID: employee.employee.id }
            await ApiClient.post("/Api/Booking/AddBookingEmployee", postData, event);
            toastr.success("Employee Added");
            this.loadAll();
        }

        async removeEmployee(employee: IEmployeeBookingVM, event: Event) {

            if (!employee.canDelete) {
                toastr.warning("Employee has allocation dates in the past!", "Cannot delete.");
                return;
            }

            const shouldDelete: boolean = await this.$bvModal.msgBoxConfirm("Are you sure you want to remove this employee? They may have dates already assigned to them.", {
                title: "Delete",
                okVariant: "danger",
                okTitle: "Yes, remove!",
                cancelTitle: "No, leave it",
                hideHeaderClose: true,
                centered: true,
                headerClass: "border-bottom-0",
                footerClass: "border-top-0",
                size: "sm"
            });
            if (!shouldDelete) return;
            const postData = { bookingID: this.booking.id, employeeID: employee.id }
            await ApiClient.post("/Api/Booking/RemoveBookingEmployee", postData, event);
            toastr.warning("Employee Removed");
            this.loadAll();
        }

        addVoucher(id: number) {
            const dialogue = this.$refs.foodVoucherModal as FoodVoucherModal & { show: () => void };
            dialogue.addNew(id);
        }

        editVoucher(id: number, voucherAmount: number, voucherCode: string, voucherCodeTotal: number) {
            const dialogue = this.$refs.foodVoucherModal as FoodVoucherModal & { show: () => void };
            dialogue.edit(id, voucherAmount, voucherCode, voucherCodeTotal);
        }
    }
